export const makeKey = <NS extends string, N extends string>(
  namespace: NS,
  name: N
) => {
  return (namespace + '.' + name) as `${NS}.${N}`;
};
